import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import DatePicker from "react-datepicker";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const parseTimeStringToDate = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const now = new Date();
    now.setHours(hours);
    now.setMinutes(minutes);
    now.setSeconds(0);
    now.setMilliseconds(0);
    return new Date(now);
  };

  const GetEditData = async () => {
    const response = await getData(`/admin/masters/time-slot/${id}`);

    const parsedData = {
      ...response?.data,
      from: parseTimeStringToDate(response?.data?.from),
      to: parseTimeStringToDate(response?.data?.to),
    };

    reset(parsedData);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      from: null,
      to: null
    }
  });
  const formatTime = (date) => {
    if (!date) return "";
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`; // 24-hour format (e.g., "14:30")
  };
  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("name", data?.name);
      const payload = {
        ...data,
        from: formatTime(data.from), // convert to HH:mm
        to: formatTime(data.to),
      };
      const response = await putData(`/admin/masters/time-slot/${id}`, payload);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
  const fromTime = watch("from");
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Time Slot
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>From Time</Form.Label>
                    <InputGroup>

                      {/* <Controller
                        control={control}
                        name="from"
                        rules={{ required: "From time is required" }}
                        render={({ field }) => (
                          <DatePicker
                            {...field}
                            ref={(r) => field.ref(r?.input)}
                            selected={field.value || null} 
                            selected={field.value}
                            onChange={field.onChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            placeholderText="Select From Time"
                            className={classNames("form-control", {
                              "is-invalid": errors?.from,
                            })}
                          />
                        )}
                      /> */}

                      <Controller
                        control={control}
                        name="from"
                        rules={{ required: "From time is required" }}
                        render={({ field }) => (
                          <DatePicker
                            {...field}
                            ref={(r) => field.ref(r?.input)}
                            selected={field.value || null}
                            onChange={field.onChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            placeholderText="Select From Time"
                            className={classNames("form-control", {
                              "is-invalid": errors?.from,
                            })}

                            // 🚫 Prevent auto-open when error shows
                            preventOpenOnFocus={true}

                            // ✅ Allow opening on click even when error exists
                            onInputClick={(e) => field.onFocus?.(e)}
                          />
                        )}
                      />


                    </InputGroup>
                    {errors.from && (
                      <span className="text-danger">{errors.from.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>To Time</Form.Label>
                    <InputGroup>
                      <Controller
                        control={control}
                        name="to"
                        rules={{
                          required: "To time is required",
                          validate: (value) => {
                            const from = fromTime;
                            const to = value;
                            if (from && to) {
                              return (
                                new Date(to) > new Date(from) ||
                                "To time must be after From time"
                              );
                            }
                            return true;
                          },
                        }}
                        render={({ field }) => (
                          <DatePicker
                            {...field}
                            selected={field.value}
                            onChange={field.onChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            placeholderText="Select To Time"
                            className={classNames("form-control", {
                              "is-invalid": errors?.to,
                            })}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.to && (
                      <span className="text-danger">{errors.to.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;

// import React, { useContext } from "react";
// import { useState, useEffect } from "react";
// import "../../Tabels/Tabels.css";
// import { Link } from "react-router-dom";
// import { Context } from "../../../utils/context";
// import { library } from "@fortawesome/fontawesome-svg-core";
// import { fas } from "@fortawesome/free-solid-svg-icons";
// // *******************toster****************************
// import ModalSave from "../../common/ModelSave";
// import { CancelButton, SaveButton } from "../../common/Button";
// import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
// import { useForm } from "react-hook-form";
// import classNames from "classnames";
// import { putData } from "../../../utils/api";
// library.add(fas);

// const EditOffCanvance = (props) => {
//   const id = props.show;
//   const { postData, getData, IMG_URL } = useContext(Context);
//   const [showModal, setShowModal] = useState({
//     code: 0,
//     message: "",
//   });

//   const GetEditData = async () => {
//     const response = await getData(`/admin/masters/time-slot/${id}`);
//     reset(response?.data);
//   };
//   useEffect(() => {
//     GetEditData();
//   }, []);

//   const {
//     control,
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//     getValues,
//     watch,
//   } = useForm();

//   const onSubmit = async (data) => {
//     try {
//       const finalData = new FormData();
//       finalData.append("name", data?.name);
//       const response = await putData(`/admin/masters/time-slot/${id}`, data);

//       if (response?.success) {
//         await setShowModal({ code: response.code, message: response.message });
//       } else {
//         await setShowModal({ code: response?.code, message: response?.errors });
//       }
//       setTimeout(() => {
//         setShowModal(0);
//         props.handleClose();
//       }, 1000);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <>
//       <Modal
//         {...props}
//         onHide={props.handleClose}
//         size="lg"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title id="contained-modal-title-vcenter">
//             Edit Time Slot
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
//             <Row className="">
//               <Col md={6}>
//                 <div className="main-form-section mt-3">
//                   <Form.Group>
//                     <Form.Label>From Time</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         type="time"
//                         {...register("from", {
//                           required: "From Time is required",
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.from,
//                         })}
//                       />
//                     </InputGroup>
//                     {errors.from && (
//                       <span className="text-danger">{errors.from.message}</span>
//                     )}
//                   </Form.Group>
//                 </div>
//               </Col>

//               <Col md={6}>
//                 <div className="main-form-section mt-3">
//                   <Form.Group>
//                     <Form.Label>To Time</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         type="time"
//                         {...register("to", {
//                           required: "To Time is required",
//                           validate: (value) => {
//                             const fromDate = new Date(watch("from"));
//                             const toDate = new Date(value);
//                             if (!isNaN(fromDate) && !isNaN(toDate)) {
//                               return (
//                                 toDate >= fromDate ||
//                                 "To Time must be after From Time"
//                               );
//                             }
//                             return true;
//                           },
//                         })}
//                         className={classNames("", {
//                           "is-invalid": errors?.to_time,
//                         })}
//                       />
//                     </InputGroup>
//                     {errors.to && (
//                       <span className="text-danger">{errors.to.message}</span>
//                     )}
//                   </Form.Group>
//                 </div>
//               </Col>

//               <Row className="mt-5 pb-3">
//                 <div className="d-flex justify-content-center">
//                   <Link>
//                     <CancelButton
//                       name={"cancel"}
//                       handleClose={props.handleClose}
//                     />
//                   </Link>

//                   <SaveButton
//                     name={"save"}
//                     handleSubmit={handleSubmit(onSubmit)}
//                   />
//                 </div>
//               </Row>
//             </Row>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       <ModalSave
//         message={showModal.message}
//         showErrorModal={showModal.code ? true : false}
//       />
//     </>
//   );
// };

// export default EditOffCanvance;
